export const uploaderConstants = {
  Domain: 'uploader'
}

export const MAX_CACHE_AGE = 60 * 60 * 24 * 30
